const API_URL = 'https://www.barcodepapel.pt:5017/costs';

class CostService {
  async getAllCosts() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar custos');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Erro ao buscar custos:', error);
      throw error;
    }
  }

  async getCostsSummary() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/summary`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar sumário de custos');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar sumário de custos:', error);
      throw error;
    }
  }

  async createEventCost(costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/event`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao criar custo de evento');
      }

      return data;
    } catch (error) {
      console.error('Erro ao criar custo de evento:', error);
      throw error;
    }
  }

  async createServiceCost(costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/service`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao criar custo de serviço');
      }

      return data;
    } catch (error) {
      console.error('Erro ao criar custo de serviço:', error);
      throw error;
    }
  }

  async createMultiDayEventCosts(costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/event-multi-day`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao criar custos multi-dia');
      }

      return data;
    } catch (error) {
      console.error('Erro ao criar custos multi-dia:', error);
      throw error;
    }
  }

  async updateEventCost(id, costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/event/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar custo de evento');
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar custo de evento:', error);
      throw error;
    }
  }

  async updateServiceCost(id, costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/service/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar custo de serviço');
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar custo de serviço:', error);
      throw error;
    }
  }

  async deleteEventCost(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/event/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Erro ao eliminar custo de evento');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao eliminar custo de evento:', error);
      throw error;
    }
  }

  async deleteServiceCost(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/service/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Erro ao eliminar custo de serviço');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao eliminar custo de serviço:', error);
      throw error;
    }
  }

  async getEventCosts(eventId) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/event/${eventId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar custos do evento');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar custos do evento:', error);
      throw error;
    }
  }

  async getServiceCosts(serviceType) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/service/${serviceType}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar custos do serviço');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar custos do serviço:', error);
      throw error;
    }
  }

  async createBookingCost(costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/booking`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao criar custo do booking');
      }

      return data;
    } catch (error) {
      console.error('Erro ao criar custo do booking:', error);
      throw error;
    }
  }

  async getBookingCost(bookingId) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/booking/${bookingId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar custo do booking');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar custo do booking:', error);
      throw error;
    }
  }

  async getAllBookingCosts() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/bookings`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar custos dos bookings');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar custos dos bookings:', error);
      throw error;
    }
  }

  async updateBookingCost(id, costData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/booking/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(costData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar custo do booking');
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar custo do booking:', error);
      throw error;
    }
  }

  async deleteBookingCost(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/booking/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Erro ao eliminar custo do booking');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao eliminar custo do booking:', error);
      throw error;
    }
  }
  formatCostValue(value) {
    return new Intl.NumberFormat('pt-PT', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }

  formatDate(date) {
    return new Date(date).toLocaleDateString('pt-PT', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  validateCostData(costData) {
    const errors = [];

    if (!costData.description || costData.description.trim() === '') {
      errors.push('Descrição é obrigatória');
    }

    if (!costData.amount || parseFloat(costData.amount) <= 0) {
      errors.push('Valor deve ser maior que zero');
    }

    if (!costData.date) {
      errors.push('Data é obrigatória');
    }

    return {
      valid: errors.length === 0,
      errors: errors
    };
  }

  prepareCostData(formData) {
    return {
      description: formData.description.trim(),
      amount: parseFloat(formData.amount),
      date: this.formatDateForAPI(formData.date),
      category: formData.category,
      eventId: formData.eventId || null,
      serviceType: formData.serviceType || null
    };
  }

  formatDateForAPI(date) {
    if (!date) return null;

    if (typeof date === 'string') {
      if (date.includes('T')) {
        return date;
      }
      return `${date}T00:00:00.000Z`;
    }

    return date.toISOString();
  }
}


export default new CostService();